<li class="list-group-item p-2 item-container" [class.canceled-item]="item.itemStatusSlug === 'canceled'">
  <!-- Columna fija (izquierda) para borrar: centrado vertical -->
  <div class="item-delete-col">
    <button class="btn btn-sm btn-outline-danger delete-btn" (click)="onCancelItem($event)" title="Cancelar ítem"
      [class.invisible]="!canCancel">
      <i class="las la-trash"></i>
    </button>
  </div>

  <!-- Contenido del ítem -->
  <div class="item-content flex-grow-1">
    <!-- First Row: Name and Quantity Controls -->
    <div class="row align-items-center gx-1 mb-1">
      <div class="col">
        <span class="item-title d-inline-block" style="max-width: 80%">{{ item.name }}</span>
        <div *ngIf="getOptionNames().length" class="text-muted small">
          {{ getOptionNames().join(', ') }}
        </div>
      </div>
      <div class="col-auto" *ngIf="item.itemStatusSlug !== 'canceled'">
        <div class="d-flex align-items-center gap-2">
          <ng-container *ngIf="canEdit; else readOnlyQty">
            <button class="btn btn-sm btn-outline-secondary px-2 py-0" (click)="onRemoveItem($event)"
              title="Disminuir cantidad">
              -
            </button>
            <div class="text-center mx-1" style="min-width: 24px">
              {{ item.qty }}
            </div>
            <button class="btn btn-sm btn-outline-secondary px-2 py-0" (click)="onAddItem($event)"
              title="Aumentar cantidad">
              +
            </button>
          </ng-container>
          <ng-template #readOnlyQty>
            <div class="text-center mx-1" style="min-width: 24px">
              {{ item.qty }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="col-auto" *ngIf="item.itemStatusSlug === 'canceled'">
        <div class="text-center" style="min-width: 24px">
          <span class="text-decoration-line-through">
            {{ item.qty }}
          </span>
        </div>
      </div>
    </div>

    <!-- Price Row: unit × qty = subtotal (below name) -->
    <div class="row mb-1">
      <div class="col">
        <div class="text-nowrap fw-medium" [class.text-decoration-line-through]="item.itemStatusSlug === 'canceled'">
          {{ item.price | currency:'CLP' }}
          <ng-container *ngIf="item.qty > 1"> × {{ item.qty }} = {{ (item.price * item.qty) | currency:'CLP'
            }}</ng-container>
        </div>
      </div>
    </div>

    <!-- Actions and Status Row -->
    <div class="row">
      <div class="col d-flex justify-content-between align-items-center gap-2">
        <!-- Action Buttons Group -->
        <div class="d-flex gap-2">
          <!-- Advance Button (disabled for 'sent') -->
          <button
            *ngIf="(item.allowedNextStatuses?.length || 0) > 0 && (item.itemStatusSlug || '').toLowerCase() !== 'sent'"
            class="btn btn-sm btn-outline-primary" [disabled]="(item.allowedNextStatuses?.length || 0) === 0"
            (click)="onAdvancePrimary()">
            Avanzar
          </button>
        </div>

        <!-- Status Badge -->
        <div>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(item.itemStatusSlug)">
            {{ getStatusLabel(item.itemStatusSlug) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</li>